import Cancel from '@mui/icons-material/Cancel';
import LocalOffer from '@mui/icons-material/LocalOffer';
import Chip from '@mui/material/Chip';
import { isDate, isValid } from 'date-fns';
import { ActionColumnCell } from 'features/gantt/components/ActionColumnCell';
import { PredecessorsCell } from 'features/tasksGantt/components/columnCells/PredecessorsCell';
import isEmpty from 'lodash/isEmpty';
import uniq from 'lodash/uniq';
import { Fragment } from 'react';
import { EFFORT_TAGS } from '../../../../../helpers/constants';
import store from '../../../../../store';
import ganttStore from '../ganttStore';
import { loadCrewMenuType } from './menu/crewMenu';
import { loadCalendarDayMenuType, loadCustomDurationMenuType } from './menu/durationMenu';
import { loadEffortMenuType } from './menu/effortMenu';
import { loadLocationMenuType } from './menu/locationMenu';
import { loadResponsibleUsersMenuType } from './menu/responsibleUserMenu';
import { loadTradeMenuType } from './menu/tradeMenu';
import { CompaniesColumnCell } from 'features/gantt/components/CompaniesColumnCell';
import { ContactsColumnCell } from 'features/gantt/components/ContactsColumnCell';
import { ResponsibleUsersColumnCell } from 'features/gantt/components/ResponsibleUsersColumnCell';
import { loadCompanyMenuType } from './menu/companyMenu';
import { loadContactMenuType } from './menu/contactMenu';

const locationIconString = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style=" height: 18px; width: 25px;"><path d="M3.92308 1.38462H12.3846C12.7654 1.38462 13.0769 1.07308 13.0769 0.692308C13.0769 0.311538 12.7654 0 12.3846 0H3.92308C3.54231 0 3.23077 0.311538 3.23077 0.692308C3.23077 1.07308 3.54231 1.38462 3.92308 1.38462ZM13.6154 2.15385H2.69231C2.31154 2.15385 2 2.46538 2 2.84615C2 3.20385 2.26538 3.50385 2.61538 3.53846V15.0769C2.61538 15.5846 3.03077 16 3.53846 16H6.92308C7.09231 16 7.23077 15.8615 7.23077 15.6923V14.1538C7.23077 13.9846 7.36923 13.8462 7.53846 13.8462H8.76923C8.93846 13.8462 9.07692 13.9846 9.07692 14.1538V15.6923C9.07692 15.8615 9.21538 16 9.38462 16H12.7692C13.2769 16 13.6923 15.5846 13.6923 15.0769V3.53846C14.0423 3.50385 14.3077 3.20385 14.3077 2.84615C14.3077 2.46538 13.9962 2.15385 13.6154 2.15385ZM5.69231 12.3077C5.69231 12.4769 5.55385 12.6154 5.38462 12.6154H4.76923C4.6 12.6154 4.46154 12.4769 4.46154 12.3077V11.6923C4.46154 11.5231 4.6 11.3846 4.76923 11.3846H5.38462C5.55385 11.3846 5.69231 11.5231 5.69231 11.6923V12.3077ZM5.69231 9.84615C5.69231 10.0154 5.55385 10.1538 5.38462 10.1538H4.76923C4.6 10.1538 4.46154 10.0154 4.46154 9.84615V9.23077C4.46154 9.06154 4.6 8.92308 4.76923 8.92308H5.38462C5.55385 8.92308 5.69231 9.06154 5.69231 9.23077V9.84615ZM5.69231 7.38462C5.69231 7.55385 5.55385 7.69231 5.38462 7.69231H4.76923C4.6 7.69231 4.46154 7.55385 4.46154 7.38462V6.76923C4.46154 6.6 4.6 6.46154 4.76923 6.46154H5.38462C5.55385 6.46154 5.69231 6.6 5.69231 6.76923V7.38462ZM5.69231 4.92308C5.69231 5.09231 5.55385 5.23077 5.38462 5.23077H4.76923C4.6 5.23077 4.46154 5.09231 4.46154 4.92308V4.30769C4.46154 4.13846 4.6 4 4.76923 4H5.38462C5.55385 4 5.69231 4.13846 5.69231 4.30769V4.92308ZM8.76923 12.3077C8.76923 12.4769 8.63077 12.6154 8.46154 12.6154H7.84615C7.67692 12.6154 7.53846 12.4769 7.53846 12.3077V11.6923C7.53846 11.5231 7.67692 11.3846 
  7.84615 11.3846H8.46154C8.63077 11.3846 8.76923 11.5231 8.76923 11.6923V12.3077ZM8.76923 9.84615C8.76923 10.0154 8.63077 10.1538 8.46154 10.1538H7.84615C7.67692 10.1538 7.53846 10.0154 7.53846 9.84615V9.23077C7.53846 9.06154 7.67692 8.92308 7.84615 8.92308H8.46154C8.63077 8.92308 8.76923 9.06154 8.76923 9.23077V9.84615ZM8.76923 7.38462C8.76923 7.55385 8.63077 7.69231 8.46154 7.69231H7.84615C7.67692 7.69231 7.53846 7.55385 7.53846 7.38462V6.76923C7.53846 6.6 7.67692 6.46154 7.84615 6.46154H8.46154C8.63077 6.46154 8.76923 6.6 8.76923 6.76923V7.38462ZM8.76923 4.92308C8.76923 5.09231 8.63077 5.23077 8.46154 5.23077H7.84615C7.67692 5.23077 7.53846 5.09231 7.53846 4.92308V4.30769C7.53846 4.13846 7.67692 4 7.84615 4H8.46154C8.63077 4 8.76923 4.13846 8.76923 4.30769V4.92308ZM11.8462 12.3077C11.8462 12.4769 11.7077 12.6154 11.5385 12.6154H10.9231C10.7538 12.6154 10.6154 12.4769 10.6154 12.3077V11.6923C10.6154 11.5231 10.7538 11.3846 10.9231 11.3846H11.5385C11.7077 11.3846 11.8462 11.5231 11.8462 11.6923V12.3077ZM11.8462 9.84615C11.8462 10.0154 11.7077 10.1538 11.5385 10.1538H10.9231C10.7538 10.1538 10.6154 10.0154 10.6154 9.84615V9.23077C10.6154 9.06154 10.7538 8.92308 10.9231 8.92308H11.5385C11.7077 8.92308 11.8462 9.06154 11.8462 9.23077V9.84615ZM11.8462 7.38462C11.8462 7.55385 11.7077 7.69231 11.5385 7.69231H10.9231C10.7538 7.69231 10.6154 7.55385 10.6154 7.38462V6.76923C10.6154 6.6 10.7538 6.46154 10.9231 6.46154H11.5385C11.7077 6.46154 11.8462 6.6 11.8462 6.76923V7.38462ZM11.8462 4.92308C11.8462 5.09231 11.7077 5.23077 11.5385 5.23077H10.9231C10.7538 5.23077 10.6154 5.09231 10.6154 4.92308V4.30769C10.6154 4.13846 10.7538 4 10.9231 4H11.5385C11.7077 4 11.8462 4.13846 11.8462 4.30769V4.92308Z" fill="currentColor"></path></svg>`;
const crewSizeIconString =
  '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="opacity: 0.4; height: 18px; width: 24px;"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.4405 4.91618C11.4405 5.73125 11.1167 6.51292 10.5404 7.08926C9.96407 7.66559 9.1824 7.98938 8.36733 7.98938C7.55227 7.98938 6.7706 7.66559 6.19426 7.08926C5.61792 6.51292 5.29414 5.73125 5.29414 4.91618C5.29414 4.10112 5.61792 3.31944 6.19426 2.74311C6.7706 2.16677 7.55227 1.84299 8.36733 1.84299C9.1824 1.84299 9.96407 2.16677 10.5404 2.74311C11.1167 3.31944 11.4405 4.10112 11.4405 4.91618ZM11.5155 8.69375C12.2916 8.04671 12.8495 7.17631 13.1133 6.20095C13.3771 5.22559 13.334 4.19264 12.9899 3.24263C12.6458 2.29261 12.0174 1.47166 11.1902 0.891468C10.363 0.311272 9.37713 0 8.36672 0C7.35631 0 6.37044 0.311272 5.54322 0.891468C4.716 1.47166 4.0876 2.29261 3.74351 3.24263C3.39943 4.19264 3.35636 5.22559 3.62018 6.20095C3.88399 7.17631 4.44187 8.04671 5.21793 8.69375C4.00781 9.26586 2.97606 10.1563 2.23312 11.2697C1.49019 12.3832 1.06403 13.6777 1.00028 15.0147C0.994346 15.2556 1.08298 15.4893 1.24721 15.6657C1.41143 15.842 1.63819 15.9471 1.87892 15.9583C2.11965 15.9696 2.35522 15.8861 2.53518 15.7258C2.71514 15.5655 2.82518 15.3412 2.84174 15.1007C2.90875 13.6803 3.52017 12.3403 4.54908 11.3588C5.57799 10.3773 6.94536 9.82969 8.36733 9.82969C9.78931 9.82969 11.1567 10.3773 12.1856 11.3588C13.2145 12.3403 13.8259 13.6803 13.8929 15.1007C13.896 15.2235 13.9235 15.3444 13.9739 15.4564C14.0242 15.5683 14.0965 15.6691 14.1863 15.7528C14.2762 15.8365 14.3819 15.9013 14.4972 15.9436C14.6124 15.9859 14.735 16.0047 14.8576 15.999C14.9803 15.9933 15.1006 15.9631 15.2114 15.9102C15.3222 15.8574 15.4214 15.783 15.5031 15.6913C15.5847 15.5996 15.6473 15.4925 15.687 15.3763C15.7267 15.2601 15.7428 15.1372 15.7344 15.0147C15.6704 13.6776 15.244 12.383 14.5009 11.2696C13.7577 10.1562 12.7258 9.2658 11.5155 8.69375Z" fill="#B3B3B3"/></svg>';
const hourGlassIconString = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style=" height: 18px; width: 24px;">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.4405 4.91618C11.4405 5.73125 11.1167 6.51292 10.5404 7.08926C9.96407 7.66559 9.1824 7.98938 8.36733 7.98938C7.55227 7.98938 6.7706 7.66559 6.19426 7.08926C5.61792 6.51292 5.29414 5.73125 5.29414 4.91618C5.29414 4.10112 5.61792 3.31944 6.19426 2.74311C6.7706 2.16677 7.55227 1.84299 8.36733 1.84299C9.1824 1.84299 9.96407 2.16677 10.5404 2.74311C11.1167 3.31944 11.4405 4.10112 11.4405 4.91618ZM11.5155 8.69375C12.2916 8.04671 12.8495 7.17631 13.1133 6.20095C13.3771 5.22559 13.334 4.19264 12.9899 3.24263C12.6458 2.29261 12.0174 1.47166 11.1902 0.891468C10.363 0.311272 9.37713 0 8.36672 0C7.35631 0 6.37044 0.311272 5.54322 0.891468C4.716 1.47166 4.0876 2.29261 3.74351 3.24263C3.39943 4.19264 3.35636 5.22559 3.62018 6.20095C3.88399 7.17631 4.44187 8.04671 5.21793 8.69375C4.00781 9.26586 2.97606 10.1563 2.23312 11.2697C1.49019 12.3832 1.06403 13.6777 1.00028 15.0147C0.994346 15.2556 1.08298 15.4893 1.24721 15.6657C1.41143 15.842 1.63819 15.9471 1.87892 15.9583C2.11965 15.9696 2.35522 15.8861 2.53518 15.7258C2.71514 15.5655 2.82518 15.3412 2.84174 15.1007C2.90875 13.6803 3.52017 12.3403 4.54908 11.3588C5.57799 10.3773 6.94536 9.82969 8.36733 9.82969C9.78931 9.82969 11.1567 10.3773 12.1856 11.3588C13.2145 12.3403 13.8259 13.6803 13.8929 15.1007C13.896 15.2235 13.9235 15.3444 13.9739 15.4564C14.0242 15.5683 14.0965 15.6691 14.1863 15.7528C14.2762 15.8365 14.3819 15.9013 14.4972 15.9436C14.6124 15.9859 14.735 16.0047 14.8576 15.999C14.9803 15.9933 15.1006 15.9631 15.2114 15.9102C15.3222 15.8574 15.4214 15.783 15.5031 15.6913C15.5847 15.5996 15.6473 15.4925 15.687 15.3763C15.7267 15.2601 15.7428 15.1372 15.7344 15.0147C15.6704 13.6776 15.244 12.383 14.5009 11.2696C13.7577 10.1562 12.7258 9.2658 11.5155 8.69375Z" fill="currentColor"/>
</svg>`;
const companyIconString = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style=" height: 18px; width: 25px;"><path d="M15 9C15 6.49219 13.46 4.34625 11.2753 3.44937L10 6V2.5C10 2.36739 9.94732 2.24021 9.85355 2.14645C9.75979 2.05268 9.63261 2 9.5 2H6.5C6.36739 2 6.24021 2.05268 6.14645 2.14645C6.05268 2.24021 6 2.36739 6 2.5V6L4.72469 3.44937C2.54 4.34625 1 6.49219 1 9V11H15V9ZM15.5 12H0.5C0.367392 12 0.240215 12.0527 0.146447 12.1464C0.0526784 12.2402 0 12.3674 0 12.5L0 13.5C0 13.6326 0.0526784 13.7598 0.146447 13.8536C0.240215 13.9473 0.367392 14 0.5 14H15.5C15.6326 14 15.7598 13.9473 15.8536 13.8536C15.9473 13.7598 16 13.6326 16 13.5V12.5C16 12.3674 15.9473 12.2402 15.8536 12.1464C15.7598 12.0527 15.6326 12 15.5 12Z" fill="currentColor"></path></svg>`;
export const warningIconString = `<svg width="1.3em" height="1.3em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="alert/warning_24px"><path id="icon/outlined/alert/warning_24px" fill-rule="evenodd" clip-rule="evenodd" d="M19.1666 17.9167L9.99998 2.08334L0.833313 17.9167H19.1666ZM9.16665 15.4167V13.75H10.8333V15.4167H9.16665ZM9.16665 12.0833H10.8333V8.75001H9.16665V12.0833Z" fill="red" fill-opacity="0.9"/></g></svg>`;
const tradeIconString = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"  data-name="Layer 1" viewBox="0 0 64 64" id="construction-worker"><path fill="currentColor" d="M55.06 22.86a5.51 5.51 0 0 0-3.19-5V22.1l-2.36 1.62L47.16 22.1V17.85a5.53 5.53 0 0 0 0 10V44.14a5.51 5.51 0 0 0 0 10V49.9l2.36-1.62 2.35 1.62v4.24a5.53 5.53 0 0 0 0-10V27.86A5.55 5.55 0 0 0 55.06 22.86zM23.94 18.37l-.18-3.82L23.69 13a3.71 3.71 0 0 1-.2-4.38l-.06-1.45-.14-2.89-.66.16a12.39 12.39 0 0 0-8.38 11.74v2.23h9.69zM29.52 14.56l-.18 3.81H39V16.14A12.42 12.42 0 0 0 30.66 4.4L30 4.24l-.13 2.88-.07 1.46a3.73 3.73 0 0 1-.2 4.39zM24.63 14.51l.18 3.86h3.66l.19-3.85 0-.72a3.7 3.7 0 0 1-4.1 0zM24.31 7.69a3.76 3.76 0 0 1 4.66 0l0-.6.17-4H24.11l.18 4z"></path><path fill="currentColor" d="M26.64 13.55a2.91 2.91 0 1 0-2.91-2.9A2.9 2.9 0 0 0 26.64 13.55zM52.3 55.06l-1.06.49c.08 1.38.06 2.6 0 3.35H44.74V53.59A6.5 6.5 0 0 1 43 49.14a2.44 2.44 0 0 1 0-.27 3.22 3.22 0 0 0-1.47-.35H41l1-5.06c.94.48 1.82 1 2.61 1.42a6.39 6.39 0 0 1 1.58-1.34 64.56 64.56 0 0 0-11.57-5.38l0-3.17a20.11 20.11 0 0 0 3.89-11.46h1.33a.83.83 0 0 0 .83-.83V20.14a.84.84 0 0 0-.83-.84H13.53a.84.84 0 0 0-.84.84V22.7a.83.83 0 0 0 .84.83h1.33a19.7 19.7 0 0 0 3.85 11.38v3.25c-3.8 1.36-15.89 6-17.71 11.65A29.82 29.82 0 0 0 .1 60a1 1 0 0 0 1 .89H52.2a1 1 0 0 0 1-.89 33 33 0 0 0 0-5.41A8.14 8.14 0 0 1 52.3 55.06zM16.85 23.53H36.44a18 18 0 0 1-3.52 10.35 1 1 0 0 0-.2.25 8 8 0 0 1-6.08 3.16 8 8 0 0 1-6.06-3.13.75.75 0 0 0-.2-.26A18.1 18.1 0 0 1 16.85 23.53zM32.64 38.37l-6 4.91-5.95-4.82V37.35a8.94 8.94 0 0 0 5.95 1.91 9.3 9.3 0 0 0 6-2.27zM11.78 48.52a3.24 3.24 0 0 0-3.23 3.24V58.9H2a26.53 26.53 0 0 1 .88-8.48c.68-2.1 3.6-4.51 8.45-7l1 5.06zm2.78 5.4a1 1 0 1 1 1-1A1 1 0 0 1 14.56 53.92zm22.21-5.4H16.51l-.73-7.09c1.67-.69 3-1.2 3.73-1.45L26 45.31a1 1 0 0 0 .63.23 1 1 0 0 0 .63-.23L33.72 40c.68.24 2.07.76 3.79 1.47zm2 5.4a1 1 0 1 1 1-1A1 1 0 0 1 38.73 53.92zM63.64 38.9a.36.36 0 0 0 .36-.37V37.19a.37.37 0 0 0-.36-.37h-2v-13l.94-1.42L62 17.69H59.32l-.52 4.68.94 1.42v13h-2a.37.37 0 0 0-.36.37v1.34a.36.36 0 0 0 .36.37h.43a3.34 3.34 0 0 1-.07 1.19h-.36a.36.36 0 0 0-.36.36v13a1.81 1.81 0 0 0 1.82 1.82h3A1.82 1.82 0 0 0 64 53.49v-13a.36.36 0 0 0-.36-.36h-.36a3.13 3.13 0 0 1-.07-1.19zM59.9 52.4a.51.51 0 1 1-1 0V42.17a.51.51 0 1 1 1 0zm2.56 0a.51.51 0 0 1-.51.51.5.5 0 0 1-.5-.51V42.17a.5.5 0 0 1 .5-.51.51.51 0 0 1 .51.51z"></path></svg>`;
export const jobwalkIconString = `<svg width="1.3em" height="1.3em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor"><path d="M5.8451 5.8451C6.49588 5.19432 6.49588 4.13886 5.8451 3.48808C5.19432 2.83731 4.13886 2.83731 3.48808 3.48808C2.83731 4.13886 2.83731 5.19432 3.48808 5.8451C4.13912 6.49614 5.19432 6.49614 5.8451 5.8451ZM12.5117 10.1547C11.8609 9.50393 10.8055 9.50393 10.1547 10.1547C9.50393 10.8055 9.50393 11.8609 10.1547 12.5117C10.8055 13.1625 11.8609 13.1625 12.5117 12.5117C13.1628 11.8609 13.1628 10.8057 12.5117 10.1547ZM12.4612 4.12792L11.8721 3.53886C11.5466 3.21335 11.019 3.21335 10.6938 3.53886L3.53886 10.6938C3.21334 11.0193 3.21334 11.5469 3.53886 11.8721L4.12792 12.4612C4.45344 12.7867 4.98104 12.7867 5.3063 12.4612L12.4612 5.3063C12.7867 4.98104 12.7867 4.45344 12.4612 4.12792Z" fill="currentColor"></path></svg>`;
export const stuckPointString = `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 16 16" height="16px" viewBox="0 0 24 24" width="16px" fill="#FFFFFF"><g><rect fill="none" height="16px" width="16px"/><path d="M17,12c-2.76,0-5,2.24-5,5s2.24,5,5,5c2.76,0,5-2.24,5-5S19.76,12,17,12z M18.65,19.35l-2.15-2.15V14h1v2.79l1.85,1.85 L18.65,19.35z M18,3h-3.18C14.4,1.84,13.3,1,12,1S9.6,1.84,9.18,3H6C4.9,3,4,3.9,4,5v15c0,1.1,0.9,2,2,2h6.11 c-0.59-0.57-1.07-1.25-1.42-2H6V5h2v3h8V5h2v5.08c0.71,0.1,1.38,0.31,2,0.6V5C20,3.9,19.1,3,18,3z M12,5c-0.55,0-1-0.45-1-1 c0-0.55,0.45-1,1-1c0.55,0,1,0.45,1,1C13,4.55,12.55,5,12,5z"/></g></svg>`;
export const lockIconString = `<svg class="locked" height="1em" width="1em" color="inherit" viewBox="0 0 24 24" aria-label="Scheduled Dates Locked"><path fill="currentColor" d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9zm9 14H6V10h12zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2"></path></svg>`;

export const formatterLabels = {
  minute: {
    full: 'minute',
    plural: 'minutes',
    short: 'min',
  },
  hour: {
    full: 'hour',
    plural: 'hours',
    short: 'h',
  },
  day: {
    full: 'day',
    plural: 'days',
    short: 'd',
  },
  week: {
    full: 'week',
    plural: 'weeks',
    short: 'w',
  },
  month: {
    full: 'month',
    plural: 'months',
    short: 'm',
  },
  year: {
    full: 'year',
    plural: 'years',
    short: 'y',
  },
};

const groups = {
  general: 'general',
  progress: 'progress',
  time: 'time',
  location: 'location',
  people: 'people',
};

export const initGanttColumns = (ganttId) => {
  const gantt = ganttStore.getGantt(ganttId);
  const formatter = gantt?.ext?.formatters.durationFormatter({
    enter: 'day',
    store: 'day',
    format: 'day',
    labels: formatterLabels,
  });
  const calendarDaysFormatter = gantt?.ext?.formatters.durationFormatter({
    enter: 'day',
    store: 'day',
    format: 'day',
    hoursPerWeek: 56,
    labels: formatterLabels,
  });
  const constraintTypeEditor = {
    type: 'select',
    map_to: 'constraint_type',
    options: [
      { key: 'asap', label: gantt.locale.labels.asap },
      { key: 'alap', label: gantt.locale.labels.alap },
      { key: 'snet', label: gantt.locale.labels.snet },
      { key: 'snlt', label: gantt.locale.labels.snlt },
      { key: 'fnet', label: gantt.locale.labels.fnet },
      { key: 'fnlt', label: gantt.locale.labels.fnlt },
      { key: 'mso', label: gantt.locale.labels.mso },
      { key: 'mfo', label: gantt.locale.labels.mfo },
    ],
  };
  const scheduledEndDateEditor = {
    type: 'scheduled_end_date',
    map_to: 'scheduled_end_date',
    min: function (taskId) {
      return gantt?.getTask(taskId)?.start_date;
    },
  };
  const forecastedEndDateEditor = {
    type: 'forecasted_end_date',
    map_to: 'forecasted_end_date',
    min: function (taskId) {
      return gantt?.getTask(taskId)?.forecasted_start_date;
    },
  };
  const linksFormatter = gantt?.ext?.formatters?.linkFormatter({ durationFormatter: formatter });
  const startDateEditor = { type: 'start_date', map_to: 'start_date' };
  const durationEditor = { type: 'custom_duration', map_to: 'auto' };
  const predecessorEditor = { type: 'predecessor', map_to: 'auto', formatter: linksFormatter };
  const crewEditor = { type: 'crew', map_to: 'auto' };
  const effortEditor = { type: 'effort', map_to: 'effort_tag' };
  const constraintDateEditor = { type: 'constraint_date', map_to: 'constraint_date' };
  const calendarDaysEditor = {
    type: 'duration',
    map_to: 'cal_days',
    formatter: calendarDaysFormatter,
  };
  const workDaysEditor = { type: 'duration', map_to: 'work_days', formatter: formatter };

  const action = {
    name: 'action',
    label: '',
    width: 130,
    max_width: 200,
    canToggle: false,
    resize: true,
    sort: false,
    onrender: (item, node) => {
      if (!item.$virtual && item.type !== 'placeholder') {
        return <ActionColumnCell ganttId={ganttId} key={`${item.id}-action-menu`} task={item} />;
      }
    },
  };

  const wbs = {
    name: '$wbs',
    label: 'WBS',
    template: function (task) {
      if (gantt?.$data?.tasksStore) return gantt.getWBSCode(task);
    },
    align: 'left',
    sort: false,
    width: '100',
    resize: true,
    canToggle: true,
    group: groups.general,
  };

  const name = {
    name: 'text',
    label: 'Name',
    align: 'left',
    canToggle: false,
    tree: true,
    width: '250',
    resize: true,
    editor: { type: 'text', map_to: 'text' },
    group: groups.general,
    template: (task) => {
      const toolOptions = gantt?.config?.tools || {};
      const tools = ['missingDependencies', 'jobwalkOpen', 'openStuckPoints']
        .filter((option) => Object.hasOwn(toolOptions, option))
        .map((option) => toolOptions[option].render(task, gantt));

      const displayOptions = gantt?.config?.display || {};
      const display = ['location', 'zone', 'area']
        .filter((option) => Object.hasOwn(displayOptions, option))
        .map((option) => displayOptions[option].render(task, gantt));

      return `<span class="${task.id === -1 || gantt.config.readonly ? 'cell_disabled' : ''} flex">
        ${[...tools, task.text, ...display].filter((option) => option !== '').join('&nbsp')}
      </span > `;
    },
  };

  const uuid = {
    name: 'uuid',
    label: 'Identifier',
    align: 'center',
    width: '150',
    resize: true,
    canToggle: true,
    hide: true,
    group: groups.general,
  };

  const predecessor = {
    name: 'predecessors',
    label: 'Predecessors',
    width: '150',
    align: 'left',
    editor: predecessorEditor,
    resize: true,
    sort: false,
    hide: true,
    canToggle: true,
    group: groups.general,
    onrender: (item, node) => {
      const labels = item.$target
        .map((linkId) => linksFormatter?.format(gantt.getLink(linkId)))
        .join(', ');
      return (
        <PredecessorsCell gantt={gantt} key={`${item.id}-predecessors-column`} task={item}>
          {labels}
        </PredecessorsCell>
      );
    },
  };

  const successorColumn = {
    name: 'successors',
    align: 'center',
    resize: true,
    canToggle: true,
    hide: true,
    width: '150',
    label: 'Successors',
    group: groups.general,
    onrender: (item, node) => {
      const disabled = true;
      const links = item.$source;
      const labels = [];
      for (let i = 0; i < uniq(links).length; i++) {
        const link = gantt?.getLink(links[i]);
        if (link) {
          labels.push(linksFormatter?.format({ ...link, type: `${link.type}` }));
        }
      }
      return (
        <div
          className={`successor-column ${disabled ? 'cell_disabled' : ''}`}
          key={`${item.id}-successor-column`}
        >
          <span className="successor-label">{labels?.join(', ')}</span>
        </div>
      );
    },
  };

  const constraintType = {
    name: 'constraint_type',
    align: 'center',
    label: 'Constraint Type',
    width: '150',
    resize: true,
    canToggle: true,
    hide: true,
    group: groups.general,
    template: function (task) {
      if (task.id === -1 || gantt.config.readonly || task.type === 'placeholder') {
        return `<span class="cell_disabled "></span>`;
      }
      return gantt.locale.labels[gantt.getConstraintType(task)];
    },
    editor: constraintTypeEditor,
  };

  const project = {
    name: 'project',
    align: 'center',
    resize: true,
    canToggle: true,
    hide: true,
    width: 150,
    label: 'Project',
    group: groups.general,
    template: function (task) {
      if (task.placeholder || task.id === -1) {
        return '';
      }
      const projects = gantt?.constants?.projects;
      const project = projects?.find((project) => project.id === task.project_id);
      return `<span class='cell_disabled capitalize'}">${
        project && project.name ? project.name : ''
      }</span>`;
    },
  };

  const taskType = {
    name: 'task_type',
    label: 'Type',
    align: 'center',
    width: '120',
    group: groups.general,
    template: (task) => (task.is_production ? 'Production' : 'Planning'),
    resize: true,
    hide: true,
    canToggle: true,
  };

  const status = {
    name: 'status',
    label: 'Status',
    align: 'center',
    resize: true,
    width: '100',
    canToggle: true,
    hide: false,
    group: groups.progress,
    template: (task) => {
      return `<span class='cell_disabled capitalize'">${task.status ? task.status : ''}</span>`;
    },
  };

  const pace = {
    name: 'pace',
    label: 'Pace',
    align: 'center',
    width: '120',
    resize: true,
    hide: false,
    canToggle: true,
    group: groups.progress,
  };

  const progress = {
    name: groups.progress,
    label: '% Complete',
    align: 'center',
    width: '110',
    resize: true,
    hide: true,
    canToggle: true,
    group: groups.progress,
    template: (task) => {
      return `<span class="cell_disabled "> ${
        (parseFloat(task?.progress * 100).toFixed(0) || 0) + '%'
      }</span>`;
    },
  };

  const pr = {
    name: 'pr',
    label: 'PR',
    align: 'center',
    group: groups.progress,
    template: (task) =>
      task.pr && (task.latest_job_walk || task.status !== 'todo')
        ? parseFloat(task.pr * 100).toFixed(0) + '%'
        : '',
    width: '120',
    resize: true,
    hide: false,
    canToggle: true,
  };

  const duration = {
    name: 'duration_string',
    label: 'Duration',
    align: 'center',
    resize: true,
    width: '100',
    sort: false,
    editor: durationEditor,
    canToggle: true,
    hide: true,
    group: groups.time,
    template: (task) => {
      if (task.duration_string) {
        return `<span class="${
          task.status !== 'todo' || gantt.hasChild(task.id) || gantt.config.readonly
            ? 'cell_disabled'
            : ''
        }">${task?.duration_string}</span>`;
      } else {
        return null;
      }
    },
    onClick: loadCustomDurationMenuType(ganttId),
  };

  const workingDays = {
    name: 'work_days',
    label: 'Working Days',
    align: 'center',
    resize: true,
    width: '120',
    sort: false,
    editor: workDaysEditor,
    canToggle: true,
    hide: true,
    group: groups.time,
    template: (task) => {
      if (task.work_days) {
        return `${task?.dates_locked_by ? lockIconString : ''}<span class="${
          task.status !== 'todo' ||
          gantt.hasChild(task.id) ||
          gantt.config.readonly ||
          task?.dates_locked_by
            ? 'cell_disabled'
            : ''
        }">${task?.work_days}</span>`;
      } else {
        return null;
      }
    },
    onClick: loadCustomDurationMenuType(ganttId),
  };

  const calendarDays = {
    name: 'cal_days',
    label: 'Calendar Days',
    align: 'center',
    resize: true,
    width: '120',
    sort: false,
    canToggle: true,
    hide: false,
    editor: calendarDaysEditor,
    group: groups.time,
    template: (task) => {
      if (task.cal_days) {
        return `${task?.dates_locked_by ? lockIconString : ''}<span class="${
          task.status !== 'todo' ||
          gantt.hasChild(task.id) ||
          gantt.config.readonly ||
          task?.dates_locked_by
            ? 'cell_disabled'
            : ''
        }">${task?.cal_days}</span>`;
      } else {
        return null;
      }
    },
    onClick: loadCalendarDayMenuType(ganttId),
  };

  const startDate = {
    name: 'start_date',
    label: 'Scheduled Start',
    width: '150',
    align: 'center',
    resize: true,
    canToggle: true,
    hide: false,
    group: groups.time,
    template: (task) => {
      const dateFormatter = gantt.date.date_to_str(gantt.config.date_grid);
      return `${task?.dates_locked_by ? lockIconString : ''}<span class="${
        task.id === -1 || gantt.config.readonly || task.status !== 'todo' || task?.dates_locked_by
          ? 'cell_disabled'
          : ''
      }">${dateFormatter(task.start_date)}</span>`;
    },
    editor: startDateEditor,
    editor_type: function () {
      const dateEditor = gantt.config.editor_types.date;
      return gantt.mixin(
        {
          get_value: function (id, column, node) {
            var selectedValue = dateEditor.get_value.apply(this, [id, column, node]);
            var task = gantt.getTask(id);
            if (isDate(selectedValue) && isValid(selectedValue)) {
              return gantt.getClosestWorkTime({
                date: selectedValue,
                task: task,
                dir: 'future',
              });
            } else {
              return task.start_date;
            }
          },
        },
        dateEditor
      );
    },
  };

  const endDate = {
    name: 'scheduled_end_date',
    label: 'Scheduled End',
    width: '150',
    align: 'center',
    resize: true,
    canToggle: true,
    hide: false,
    group: groups.time,
    min: (taskId) => gantt.getTask(taskId)?.start_date,
    template: (task) => {
      const dateFormatter = gantt.date.date_to_str(gantt.config.date_grid);
      return `${task?.dates_locked_by ? lockIconString : ''}<span 
      class="${
        task.id === -1 ||
        gantt.config.readonly ||
        task.status === 'complete' ||
        task?.dates_locked_by
          ? 'cell_disabled'
          : ''
      }"
      >
        ${dateFormatter(
          gantt.date.add(
            task?.scheduled_end_date ? task.scheduled_end_date : task.end_date,
            -1,
            'day'
          )
        )}</span>`;
    },
    editor: scheduledEndDateEditor,
    editor_type: function () {
      const dateEditor = gantt.config.editor_types.date;
      return gantt.mixin(
        {
          set_value: function (value, id, column, node) {
            var correctedValue = gantt.date.add(value, -1, 'day');
            return dateEditor.set_value.apply(this, [correctedValue, id, column, node]);
          },
          get_value: function (id, column, node) {
            var selectedValue = dateEditor.get_value.apply(this, [id, column, node]);
            var task = gantt.getTask(id);
            if (isDate(selectedValue) && isValid(selectedValue)) {
              if (!gantt.isWorkTime({ date: selectedValue, task: task })) {
                return gantt.getClosestWorkTime({
                  date: selectedValue,
                  task: task,
                  dir: 'past',
                });
              } else {
                return gantt.date.add(selectedValue, 1, 'day');
              }
            } else {
              return task.scheduled_end_date;
            }
          },
        },
        dateEditor
      );
    },
  };

  const forecastedStartDate = {
    name: 'forecasted_start_date',
    label: 'Forecasted Start',
    width: '150',
    align: 'center',
    resize: true,
    canToggle: true,
    hide: true,
    group: groups.time,
    template: (task) => {
      const dateFormatter = gantt.date.date_to_str(gantt.config.date_grid);
      return `<span class='cell_disabled'>
        ${dateFormatter(task?.forecasted_start_date || task.start_date)}
        </span>`;
    },
    editor: { type: 'forecasted_start_date', map_to: 'forecasted_start_date' },
    editor_type: function () {
      const dateEditor = gantt.config.editor_types.date;
      return gantt.mixin(
        {
          get_value: function (id, column, node) {
            var selectedValue = dateEditor.get_value.apply(this, [id, column, node]);
            var task = gantt.getTask(id);
            return gantt.getClosestWorkTime({
              date: selectedValue,
              task: task,
              dir: 'future',
            });
          },
        },
        dateEditor
      );
    },
  };

  const forecastedEndDate = {
    name: 'forecasted_end_date',
    label: 'Forecasted End',
    width: '150',
    align: 'center',
    resize: true,
    min: (taskId) => gantt.getTask(taskId)?.forecasted_start_date,
    canToggle: true,
    hide: true,
    group: groups.time,
    template: (task) => {
      const dateFormatter = gantt.date.date_to_str(gantt.config.date_grid);
      return `<span class="cell_disabled">
        ${dateFormatter(
          gantt.date.add(
            task?.forecasted_end_date || task.scheduled_end_date || task.end_date,
            -1,
            'day'
          )
        )}
        </span>`;
    },
    editor: forecastedEndDateEditor,
    editor_type: function () {
      const dateEditor = gantt.config.editor_types.date;
      return gantt.mixin(
        {
          set_value: function (value, id, column, node) {
            var correctedValue = gantt.date.add(value, -1, 'day');
            return dateEditor.set_value.apply(this, [correctedValue, id, column, node]);
          },
          get_value: function (id, column, node) {
            var selectedValue = dateEditor.get_value.apply(this, [id, column, node]);
            var task = gantt.getTask(id);
            if (!gantt.isWorkTime({ date: selectedValue, task: task })) {
              return gantt.getClosestWorkTime({
                date: selectedValue,
                task: task,
                dir: 'past',
              });
            } else {
              return gantt.date.add(selectedValue, 1, 'day');
            }
          },
        },
        dateEditor
      );
    },
  };

  const actualStartDate = {
    name: 'actual_start_date',
    label: 'Actual Start',
    width: '150',
    align: 'center',
    resize: true,
    canToggle: true,
    hide: true,
    group: groups.time,
    template: (task) => {
      const dateFormatter = gantt.date.date_to_str(gantt.config.date_grid);
      return task.actual_start_date
        ? `<span class='cell_disabled'>
          ${dateFormatter(task.actual_start_date)}
          </span>`
        : '';
    },
  };
  const actualEndDate = {
    name: 'actual_end_date',
    label: 'Actual End',
    width: '150',
    align: 'center',
    resize: true,
    canToggle: true,
    hide: true,
    group: groups.time,
    template: (task) => {
      const dateFormatter = gantt.date.date_to_str(gantt.config.date_grid);
      return task.actual_end_date
        ? `<span class='cell_disabled'>
          ${dateFormatter(gantt.date.add(task.actual_end_date, -1, 'day'))}
          </span>`
        : '';
    },
  };

  const effortHours = {
    name: 'hours',
    label: 'Hours',
    width: '100',
    align: 'center',
    resize: true,
    canToggle: true,
    hide: true,
    editor: { type: 'effort_hours', map_to: 'auto' },
    group: groups.time,
    template: function (task) {
      if (task.id === -1 || gantt.config.readonly) {
        return `<span class="cell_disabled "> ${hourGlassIconString}</span>`;
      }
      let dom = [
        hourGlassIconString,
        `${
          task.effort_hours ? `<div>${parseFloat(task.effort_hours).toFixed(2) + 'h'}</div>` : ''
        } `,
      ];
      return dom.join('');
    },
    editor_type: function () {
      const numberEditor = gantt.config.editor_types.number;
      return gantt.mixin(
        {
          set_value: function (value, id, column, node) {
            var correctedValue = parseFloat(value.effort_hours);
            return numberEditor.set_value.apply(numberEditor, [correctedValue, id, column, node]);
          },
          save: (id, column, node) => {
            let effortHours = parseFloat(
              numberEditor.get_value.apply(numberEditor, [id, column, node])
            );
            let task = gantt.getTask(id);
            task.effort_hours = !isNaN(effortHours) ? effortHours.toFixed(2) : undefined;
            task.effort_tag = null;
            gantt.updateTask(id);
          },
        },
        numberEditor
      );
    },
  };

  const constraintDate = {
    name: 'constraint_date',
    label: 'Constraint Date',
    align: 'center',
    width: '150',
    resize: true,
    canToggle: true,
    hide: true,
    editor: constraintDateEditor,
    group: groups.time,
    editor_type: function () {
      const dateEditor = gantt.config.editor_types.date;
      return gantt.mixin(
        {
          get_value: function (id, column, node) {
            var selectedValue = dateEditor.get_value.apply(this, [id, column, node]);
            var task = gantt.getTask(id);
            if (isDate(selectedValue) && isValid(selectedValue)) {
              return gantt.getClosestWorkTime({
                date: selectedValue,
                task: task,
                dir: 'future',
              });
            } else {
              return null;
            }
          },
        },
        dateEditor
      );
    },
    template: function (task) {
      if (task.type === 'placeholder' || task.id === -1) {
        return '';
      }
      const constraintTypes = gantt.config.constraint_types;
      if (
        task.constraint_date &&
        task.constraint_type != constraintTypes.ASAP &&
        task.constraint_type != constraintTypes.ALAP
      ) {
        return task.constraint_date;
      }
      return '';
    },
  };

  const totalSlack = {
    name: 'totalFloat',
    align: 'center',
    resize: true,
    canToggle: true,
    hide: true,
    width: '120',
    label: 'Total Float',
    group: groups.time,
    template: function (task) {
      if (task.placeholder) {
        return '';
      }
      if (gantt.isSummaryTask(task)) {
        return '';
      }
      return task.total_float;
    },
  };

  const freeSlack = {
    name: 'freeFloat',
    align: 'center',
    resize: true,
    canToggle: true,
    hide: true,
    width: '120',
    label: 'Free Float',
    group: groups.time,
    template: function (task) {
      if (task.placeholder) {
        return '';
      }
      if (gantt.isSummaryTask(task)) {
        return '';
      }
      return task.free_float;
    },
  };

  const earned_days = {
    name: 'earned_days',
    label: 'Earned Days',
    align: 'center',
    width: '120',
    group: groups.time,
    template: (task) =>
      task.earned_days && (task.latest_job_walk || task.status !== 'todo')
        ? parseFloat(task.earned_days).toFixed(2)
        : '',
    resize: true,
    hide: true,
    canToggle: true,
  };

  const earned_planned_days = {
    name: 'earned_planned_days',
    label: 'Earned Planned Days',
    align: 'center',
    width: '120',
    group: groups.time,
    template: (task) =>
      task.earned_planned_days && (task.latest_job_walk || task.status !== 'todo')
        ? parseFloat(task.earned_planned_days).toFixed(2)
        : '',
    resize: true,
    hide: true,
    canToggle: true,
  };

  const location = {
    name: 'location_id',
    label: 'Location',
    width: '100',
    editor: { type: 'location', map_to: 'auto' },
    resize: true,
    sort: false,
    canToggle: true,
    hide: true,
    group: groups.location,
    template: function (task) {
      if (task.id === -1) {
        return `<span class="cell_disabled "> ${locationIconString}</span> `;
      }
      const lbsData = gantt?.constants?.lbsData;
      const locationName =
        task.location_id && !isEmpty(lbsData?.locations)
          ? lbsData?.locations[task.location_id]?.name
          : null;
      let dom = locationName ? locationName : locationIconString;
      return dom;
    },
    onClick: loadLocationMenuType(ganttId),
  };

  const zone = {
    name: 'zone_id',
    label: 'Zone',
    width: '100',
    resize: true,
    sort: false,
    canToggle: true,
    hide: true,
    editor: { type: 'location', map_to: 'auto' },
    group: groups.location,
    template: function (task) {
      if (task.id === -1) {
        return `<span class="cell_disabled "> ${locationIconString}</span> `;
      }
      const lbsData = gantt?.constants?.lbsData;
      const zoneName =
        task.zone_id && !isEmpty(lbsData?.zones) ? lbsData?.zones[task.zone_id]?.name : null;
      let dom = zoneName ? zoneName : locationIconString;
      return dom;
    },
    onClick: loadLocationMenuType(ganttId),
  };

  const area = {
    name: 'area_id',
    label: 'Area',
    width: '100',
    resize: true,
    // sort: false,
    canToggle: true,
    hide: true,
    editor: { type: 'location', map_to: 'auto' },
    group: groups.location,
    template: function (task) {
      if (task.id === -1) {
        return `<span class="cell_disabled "> ${locationIconString}</span> `;
      }
      const lbsData = gantt?.constants?.lbsData;
      const areaName =
        task.area_id && !isEmpty(lbsData?.areas) ? lbsData?.areas[task.area_id]?.name : null;
      let dom = areaName ? areaName : locationIconString;
      return dom;
    },
    onClick: loadLocationMenuType(ganttId),
  };

  const effortTag = {
    name: 'effort_tag',
    label: 'Effort',
    width: '150',
    align: 'center',
    resize: true,
    canToggle: true,
    hide: true,
    editor: effortEditor,
    group: groups.people,
    onrender: (item, node) => (
      <Fragment key={`${item.id}-effort-column`}>
        {item.effort_tag ? (
          <Chip
            deleteIcon={<Cancel fontSize="small" style={{ height: 16 }} />}
            label={item.effort_tag}
            size="small"
            style={{ backgroundColor: EFFORT_TAGS[item.effort_tag] }}
            onDelete={() => {
              item.effort_tag = null;
              gantt.updateTask(item.id);
            }}
          />
        ) : (
          <LocalOffer
            className={`${item.id === -1 || gantt.config.readonly ? 'cell_disabled' : ''} `}
            fontSize={'small'}
            htmlColor={'#C4C4C4'}
          />
        )}
      </Fragment>
    ),
    onClick: loadEffortMenuType(ganttId),
  };

  const crewSize = {
    name: 'crew_size',
    label: 'Crew',
    resize: true,
    canToggle: true,
    editor: crewEditor,
    width: '100',
    // sort: false,
    align: 'center',
    hide: true,
    group: groups.people,
    template: function (task) {
      if (task.id === -1) {
        return `<span class="cell_disabled "> ${crewSizeIconString}</span>`;
      }
      let dom = [crewSizeIconString, `${task?.crew_size ? `<div>${task.crew_size}</div>` : ''} `];
      return dom.join('');
    },
    onClick: loadCrewMenuType(ganttId),
  };

  const companies = {
    name: 'companies',
    label: 'Companies',
    width: '150',
    resize: true,
    sort: false,
    hide: true,
    canToggle: true,
    editor: { type: 'company', map_to: 'auto' },
    group: groups.people,
    onrender: (item, node) => {
      return <CompaniesColumnCell key={`${item.id}-companies`} task={item} />;
    },
    onClick: loadCompanyMenuType(ganttId),
  };

  const contacts = {
    name: 'contacts',
    label: 'Contacts',
    width: '150',
    resize: true,
    sort: false,
    hide: true,
    canToggle: true,
    editor: { type: 'contact', map_to: 'auto' },
    group: groups.people,
    onrender: (item, node) => {
      return <ContactsColumnCell key={`${item.id}-contacts`} task={item} />;
    },
    onClick: loadContactMenuType(ganttId),
  };

  const responsible = {
    name: 'responsible_users',
    label: 'Responsible',
    width: '150',
    resize: true,
    sort: false,
    hide: true,
    canToggle: true,
    editor: { type: 'responsible_users', map_to: 'responsible_users' },
    group: groups.people,
    onrender: (item, node) => {
      return <ResponsibleUsersColumnCell key={`${item.id}-responsible-users`} task={item} />;
    },
    onClick: loadResponsibleUsersMenuType(ganttId),
  };

  const trades = {
    name: 'trades',
    label: 'Trades',
    width: '150',
    resize: true,
    sort: false,
    hide: true,
    canToggle: true,
    editor: { type: 'trades', map_to: 'trades' },
    group: groups.people,
    template: (task) => {
      if (task.id === -1 || gantt.config.readonly) {
        return `<span class="cell_disabled "> ${tradeIconString}</span>`;
      }

      const tradeEntities = store.getState()?.api?.queries['getTrades(undefined)']?.data?.entities;

      if (!tradeEntities || !task.trades) {
        return tradeIconString;
      }

      const trades = task.trades.map((tradeId) => tradeEntities[tradeId]?.name).filter(Boolean);

      if (trades.length > 0) {
        return trades
          .map((tradeName, index) => {
            const tradeNameArray = tradeName ? tradeName.split(' ') : [];

            return `<div class="company-avatar company-grid-icon" style="z-index:${trades.length - index}; margin-left:${index > 0 ? '-8px' : '0px'}">
            ${
              tradeNameArray.length > 1
                ? tradeNameArray.map((name) => name.slice(0, 1).toUpperCase()).join('')
                : tradeNameArray[0]?.slice(0, 2).toUpperCase()
            }
          </div>`;
          })
          .join('');
      } else {
        return tradeIconString;
      }
    },

    onClick: loadTradeMenuType(ganttId),
  };

  // const text = {
  //   name: 'text',
  //   label: 'Text',
  //   align: 'center',
  //   width: '150',
  //   resize: true,
  //   canToggle: true,
  // };

  return [
    action,
    wbs,
    name,
    uuid,
    calendarDays,
    workingDays,
    duration,
    status,
    startDate,
    endDate,
    forecastedStartDate,
    forecastedEndDate,
    actualStartDate,
    actualEndDate,
    effortTag,
    effortHours,
    predecessor,
    crewSize,
    location,
    zone,
    area,
    companies,
    contacts,
    responsible,
    constraintType,
    constraintDate,
    totalSlack,
    progress,
    freeSlack,
    project,
    successorColumn,
    pace,
    earned_days,
    earned_planned_days,
    pr,
    trades,
    taskType,
  ];
};
